import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pioneer-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.css']
})
export class ValidationMessageComponent implements OnInit {

  @Input()
  public for: string;

  @Input()
  public error: string;

  @Input()
  public message: string;

  @Input()
  takeSpace = false;

  private control: AbstractControl | ControlContainer;

  constructor(private form: ControlContainer, private translateService: TranslateService) {
    if (!this.form) {
      throw new Error(`A form ControlContainer could not be found. The ValidationMessageComponent must exists within a "formGroup"`);
    }
  }

  get valid(): boolean {
    // If the user has touched the control then validate it, otherwise it should be considered valid.
    return this.control.touched ? !this.control.hasError(this.error) : true;
  }

  getValidationMessage(error): string {
    // Return the user specified validation message if present, otherwise
    // fall back to the default message configured in the transaltion service
    const key = `MESSAGES.VALIDATION.${error.toUpperCase()}`;
    return this.translateService.instant(this.message || key);
  }

  ngOnInit() {
    // If the "for" attribute is specified find the control with a matching value in the formControlName attribute
    // otherwise return the form itself.  This allows for both input and form level validation to be handled.
    this.control = this.for ? this.form.control.get(this.for) : this.form;

    // Ensure that a form control is found with the correct name if the "for" attribute is specified
    if (this.for && !this.control) {
      throw new Error(`Value in the "for" attribute: "${this.for}" could not be located in a corresponding "formControlName"`);
    }

    // Ensure the "error" attribute is specified. IE: "required", "minlength"
    if (!this.error) {
      throw new Error(`A value in the "error" attribute is required and should be the name of the rule associated with this message.`);
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/validation-message/validation-message.component.ts